import { components } from '@/utils'

function renderIcon(h) {
  if (this.icon) {
    return h(
      components.icon,
      {
        props: {
          value: this.icon,
          size: this.size - 2,
          color: this.iconColor
        }
      }
    )
  }
}

function renderContent(h) {
  return this.value ?? this.$slots.default ?? renderIcon.call(this, h)
}

export default function(h) {
  return h(
    'div',
    {
      class: this.$_class,
      style: this.$_style,
      directives: this.$_directives
    },
    [ renderContent.call(this, h) ]
  )
}
